import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";

import { errorMessage } from "@/components/ui-bits";
import { client } from "@/utils/orpc";

/** Open this server's Plane (optionally at a path such as /<workspace>/browse/ACME-9/) in a new tab. */
export function useOpenPlane(id: string) {
  return useMutation({
    mutationFn: (to?: string) => client.servers.planeLink({ id, to }),
    onSuccess: ({ url }) => window.open(url, "_blank", "noopener"),
    onError: (e) => toast.error(errorMessage(e)),
  });
}

export const taskPath = (workspace: string | null | undefined, key: string) =>
  workspace ? `/${workspace}/browse/${key}/` : undefined;
